/**
 * Comfort Cream theme only (16 Oct 2026, temporary): the swap in snippets/tn-cosmetic-copy.liquid, applied to text
 * drawn after the page loads (cart drawer, filters, variant changes, review and bundle apps). Changes text and
 * readable attributes only, never links or sources. The brand name stays, and customer reviews (Judge.me) are left
 * word for word (Daniel, 16 Oct 2026).
 */
(() => {
  const root = document.documentElement;
  if (root.dataset.tnCosmeticCopy === 'on') return;
  root.dataset.tnCosmeticCopy = 'on';

  const PATTERN = /(?<!totally\s)\b(topical\s+numbing|numbness|numbing|numbed|numbs|numb)\b/gi;
  const HAS_WORD = new RegExp(PATTERN.source, 'i');
  const REPLACEMENTS = { numbed: 'comforted', numbs: 'comforts' };
  const ATTRIBUTES = ['alt', 'title', 'placeholder', 'aria-label'];
  const SKIPPED = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA']);
  const REVIEWS = '[class*="jdgm"], [class*="judgeme"]';

  function inReview(element) {
    return Boolean(element && element.closest(REVIEWS));
  }

  function matchCase(source, word) {
    if (source.length > 1 && source === source.toUpperCase()) return word.toUpperCase();
    if (source[0] === source[0].toUpperCase()) return word[0].toUpperCase() + word.slice(1);
    return word;
  }

  function swap(text) {
    return text.replace(PATTERN, (match) => {
      const key = match.toLowerCase();
      // A capitalised "Numb" on its own is the brand, even split from "Totally" by markup.
      if (key === 'numb' && match !== 'numb') return match;
      return matchCase(match, REPLACEMENTS[key] || 'comfort');
    });
  }

  function fixText(node) {
    if (!node.nodeValue || !HAS_WORD.test(node.nodeValue)) return;
    if (node.parentElement && SKIPPED.has(node.parentElement.tagName)) return;
    if (inReview(node.parentElement)) return;
    node.nodeValue = swap(node.nodeValue);
  }

  function fixElement(element) {
    if (inReview(element)) return;
    for (const name of ATTRIBUTES) {
      const value = element.getAttribute(name);
      if (value && HAS_WORD.test(value)) {
        element.setAttribute(name, swap(value));
      }
    }
    if (element.shadowRoot) watch(element.shadowRoot);
  }

  function fixTree(start) {
    if (start.nodeType === Node.TEXT_NODE) {
      fixText(start);
      return;
    }
    if (start.nodeType === Node.ELEMENT_NODE) {
      if (SKIPPED.has(start.tagName)) return;
      fixElement(start);
    }
    const walker = document.createTreeWalker(start, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: (node) =>
        node.nodeType === Node.ELEMENT_NODE && (SKIPPED.has(node.tagName) || inReview(node))
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT,
    });
    let node = walker.nextNode();
    while (node) {
      if (node.nodeType === Node.TEXT_NODE) fixText(node);
      else fixElement(node);
      node = walker.nextNode();
    }
  }

  const watched = new WeakSet();

  function watch(target) {
    if (watched.has(target)) return;
    watched.add(target);
    fixTree(target);
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') fixText(mutation.target);
        else if (mutation.type === 'attributes') fixElement(mutation.target);
        else mutation.addedNodes.forEach(fixTree);
      }
    }).observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ATTRIBUTES,
    });
  }

  document.title = swap(document.title);
  watch(document.body);
})();
